import { Box, MenuItem, TextField } from "@mui/material";
import { SyncQueueStatus } from "@home-health-notify/models";
import { SearchBox } from "../common/SearchBox";
import { HistoryToolbar } from "./EmrPatients.style";
import {
  SYNC_QUEUE_STATUS_LABEL,
  SYNC_QUEUE_STATUS_ORDER,
} from "./syncQueueConstants";

const ALL_VALUE = "ALL";

// Status values that can appear in History (everything except pending).
const HISTORY_STATUSES = SYNC_QUEUE_STATUS_ORDER.filter(s => s !== "pending");

type HistoryControlsProps = {
  status: SyncQueueStatus | undefined;
  onStatusChange: (value: SyncQueueStatus | undefined) => void;
  search: string;
  onSearchChange: (value: string) => void;
};

export default function HistoryControls({
  status,
  onStatusChange,
  search,
  onSearchChange,
}: HistoryControlsProps) {
  return (
    <HistoryToolbar>
      <Box sx={{ flex: 1, minWidth: 240 }}>
        <SearchBox
          placeholderLabel="Search by patient name or MRN"
          searchTestId="search-emr-patients"
          searchText={search}
          onSearchTextChange={onSearchChange}
          onSearchClear={() => onSearchChange("")}
        />
      </Box>
      <TextField
        select
        size="small"
        label="Status"
        sx={{ minWidth: 180 }}
        slotProps={{ htmlInput: { "data-testid": "history-status-filter" } }}
        value={status ?? ALL_VALUE}
        onChange={e => {
          const value = e.target.value;
          onStatusChange(
            value === ALL_VALUE ? undefined : (value as SyncQueueStatus),
          );
        }}
      >
        <MenuItem value={ALL_VALUE}>All statuses</MenuItem>
        {HISTORY_STATUSES.map(option => (
          <MenuItem key={option} value={option}>
            {SYNC_QUEUE_STATUS_LABEL[option]}
          </MenuItem>
        ))}
      </TextField>
    </HistoryToolbar>
  );
}
